<template>
    <div class="commonFormStyles pound-detail">
        <HeaderNav
            header-title="磅单详情"
            left-icon-name=""
            right-icon-name=""
        ></HeaderNav>
        <div class="main-wrapper">
            <p class="warning">
                注：务必输入司机和车辆信息，以免车辆无法入场
            </p>
            <div class="message-wrapper">
                <p class="title">
                    <i class="iconfont icondingdan"></i>过磅单编号:{{ details.balance_number }}
                </p>
                <ul class="msg-wrapper">
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-1"></i><span class="msg-title ">供应单编号</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.task_number }}</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-2"></i><span class="msg-title">供应商名称</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.supplier_name }}</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-3"></i><span class="msg-title">物料名称</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.type_name }}</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-4"></i><span class="msg-title">物料规格</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.spec_name }}</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-6"></i><span class="msg-title">品牌/货源地</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.source_name }}</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-7"></i><span class="msg-title">接收场站</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.station_name }}</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-17"></i><span class="msg-title">车牌号</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.plate_number }}</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-8"></i><span class="msg-title">毛重</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.gross_weight }}吨</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-9"></i><span class="msg-title">皮重</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.tare_weight }}吨</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-10"></i><span class="msg-title">净重</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.net_weight }}吨</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-10"></i><span class="msg-title">实际净重</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.net_weight-details.deduction_weight-details.deduction_water }}吨</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-12"></i><span class="msg-title">扣吨</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.deduction_weight }}吨</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-13"></i><span class="msg-title">扣水</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.deduction_water }}吨</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-15"></i><span class="msg-title">备注</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.remarks }}</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-16"></i><span class="msg-title">快检结果</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ details.result | resultState }}</span>
                            </van-col>
                        </van-row>
                    </li>
                </ul>
            </div>
        </div>
        <!-- <span v-if="details.confirm_status===0" class="submit-btn" @click="submitChange">确认</span> -->
        <span class="return-btn" @click="handleBack"><i class="iconfont ">&#xe607;</i></span>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Toast, Dialog } from 'vant';
export default {
    components: {
        HeaderNav,
    },
    data() {
        return {
            details: {},
        };
    },
    filters: {
        resultState(state) {
            switch (state) {
                case 0:
                    return '未检测';
                case 1:
                    return '快检通过';
                case 2:
                    return '快检通过';
                case 3:
                    return '退货';
                default:
                    return '';
            }
        },
    },
    created() {
        this.details = this.$route.params.row;
    },
    methods: {
        handleBack() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        submitChange() {
            Dialog.confirm({
                message: '确定要提交？',
            }).then(() => {
                Toast.loading({
                    message: '请求中...',
                    forbidClick: false,
                    loadingType: 'spinner',
                });
                this.$axios
                    .put('/interfaceApi/procurement/balance/confirm/' + this.details.id)
                    .then(() => {
                        Toast.success({
                            message: '提交成功',
                            duration: 500,
                        });
                        setTimeout(() => {
                            this.$router.isBack = 1;
                            this.$router.go(-1);
                        }, 1000);
                    })
                    .catch(error => {
                        this.$toast('message:' + error.ErrorCode.Message + '');
                    });
            }).catch(() => {});
        },
    },
};
</script>

<style lang="stylus">
.pound-detail
    padding-top 44rpx
    height calc(100% - 44rpx)
    background rgba(240,240,240,1)
    position relative
    .return-btn
        position absolute
        top 11rpx
        left 15rpx
        color #fff
        font-size 10rpx
        z-index 999
    .main-wrapper
        height 100%
        overflow-y auto
        overflow-x hidden
        .warning
            width 100%
            height 30rpx
            line-height 30rpx
            background rgba(254,229,229,1)
            color #E60000
            text-align center
            font-size 12rpx
        .message-wrapper
            background #ffffff
            .title
                height 45rpx
                line-height 45rpx
                color #3495FB
                font-size 16rpx
                padding-left 15px
                border-bottom 2rpx solid rgba(240,240,240,1)
                i
                    margin-right 15rpx
            .msg-wrapper
                .msg-item
                    height 45rpx
                    line-height 45rpx
                    border-bottom 2rpx solid rgba(240,240,240,1)
                    .msg-title
                        margin-left 15rpx
                        // padding-left 15rpx
                        display block
                        // width 100%
                        font-size 16rpx
                    i
                        width: 16rpx
                        height 16rpx
                        background url(./../../assets/images/icons/icon_gy_1.png)
                        background-size 100% 100%
                        display inline-block
                        float left
                        margin 15rpx
                        &.title-2
                            background url(./../../assets/images/icons/icon_gy_3.png)
                            background-size 100% 100%
                        &.title-3
                            background url(./../../assets/images/icons/icon_29.png)
                            background-size 100% 100%
                        &.title-4
                            background url(./../../assets/images/icons/icon_gy_5.png)
                            background-size 100% 100%
                        &.title-5
                            background url(./../../assets/images/icons/icon_43.png)
                            background-size 100% 100%
                        &.title-6
                            background url(./../../assets/images/icons/icon_30.png)
                            background-size 100% 100%
                        &.title-7
                            background url(./../../assets/images/icons/icon_gy_8.png)
                            background-size 100% 100%
                        &.title-8
                            background url(./../../assets/images/icons/icon_gy_10.png)
                            background-size 100% 100%
                        &.title-9
                            background url(./../../assets/images/icons/icon_gy_10.png)
                            background-size 100% 100%
                        &.title-10
                            background url(./../../assets/images/icons/icon_gy_10.png)
                            background-size 100% 100%
                        &.title-11
                            background url(./../../assets/images/icons/icon_gy_10.png)
                            background-size 100% 100%
                        &.title-12
                            background url(./../../assets/images/icons/icon_gy_10.png)
                            background-size 100% 100%
                        &.title-13
                            background url(./../../assets/images/icons/icon_gy_10.png)
                            background-size 100% 100%
                        &.title-14
                            background url(./../../assets/images/icons/icon_gy_7.png)
                            background-size 100% 100%
                        &.title-15
                            background url(./../../assets/images/icons/icon_34.png)
                            background-size 100% 100%
                        &.title-16
                            background url(./../../assets/images/icons/icon_37.png)
                            background-size 100% 100%
                        &.title-17
                            background url(./../../assets/images/icons/icon_gy_9.png)
                            background-size 100% 100%
                    .msg-content
                        display block
                        width 100%
                        text-align right
                        padding-right 15rpx
                        color #979EA7
                        font-size 14rpx
        .driver-wrapper
            background #ffffff
            margin-top 15rpx
            .warning
                width 100%
                height 30rpx
                line-height 30rpx
                background rgba(254,229,229,1)
                color #E60000
                text-align center
                font-size 12rpx
            .driver-header-wrapper
                width 100%
                height 45rpx
                line-height 45rpx
                color #3495FB
                .driver-msg
                    font-size 16rpx
                    padding-left 15rp
                    margin-left 15rpx
                    i
                        margin-right 15rpx
                        width 16rpx
                        height 16rpx
                        display inline-block
                .driver-select
                    font-size 14rpx
                    text-align right
                    display block
                    margin-right 15rpx
            .driver-list
                .driver-item
                    border-bottom 2rpx solid rgba(240,240,240,1)
                    padding 15rpx
                    overflow hidden
                    p
                        height 18rpx
                        &:nth-child(2)
                            padding-top 15rpx
                    i
                        width: 18rpx
                        height 18rpx
                        background url(./../../assets/images/icons/icon_gy_9.png)
                        background-size 100% 100%
                        display inline-block
                        float left
                        margin-top 2rpx
                    .driver-platenumber
                        font-size 16rpx
                        margin-left 15rpx
                        line-height 18rpx
                    .driver-name
                        padding-left 33rpx
                        color #979EA7
                    .driver-phone
                        text-align right
                        display block
                        color #979EA7
</style>